import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { catchError, throwError } from 'rxjs';

// Environement
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CmsService {

  cmsUrl = environment.cmsUrl;
  cmsKey = environment.cmsKey;

  constructor(public httpClient: HttpClient,) { }

  // CMS - List
  getContentList(content_name: string, content_language: string){
    let options = {
      headers: {
        'Authorization': 'Bearer ' + this.cmsKey,
      },
      observe: 'response' as 'body',
    }

    return this.httpClient.get<any>(this.cmsUrl + content_name + '?populate=*&locale=' + content_language, options).pipe(
      catchError(this.handleError)
    )
  }

  // CMS - Detail

  getContent(content_name: string, content_id: string, content_language: string){
    let options = {
      headers: {
        'Authorization': 'Bearer ' + this.cmsKey,
      },
      observe: 'response' as 'body',
    }

    return this.httpClient.get<any>(this.cmsUrl + content_name + '/' + content_id + '?populate=*&locale=' + content_language, options).pipe(
      catchError(this.handleError)
    )
  }

  handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      // console.error('An error occurred:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      // console.error(`Backend returned code ${error.status}, ` + `body was: ${error.error}`);
      return throwError(error);
    }
    // return an observable with a user-facing error message
    return throwError(
      'Something bad happened; please try again later.');
  }

}
